'use client';

import type { ReactNode } from 'react';

import { ProductCardCta } from '@vs-shop/commerce-ui/productCard';

import Link from '@vs-shop/image-link/Link';

type Props = {
  href: string;
  title: string;
  children: ReactNode;
};

/**
 * The card's primary control, with its link element built on the client side
 * of the boundary.
 *
 * `ProductCardCta` takes its link as a `render` element, and Base UI's
 * `useRender` clones that element. An element that crosses from a server
 * component into a client prop is not guaranteed to arrive as an element:
 * React Flight defers any element it meets once the row it is writing passes
 * its size budget, and the client then receives a lazy reference. Only React's
 * own child rendering resolves a lazy reference; `cloneElement` turns it into an
 * element with no type, and SSR fails with `Element type is invalid`. A rail of
 * a few dozen cards crosses that budget. This component takes the link as data,
 * so the element never crosses the boundary.
 */
export default function ProductCardCtaLink({ href, title, children }: Props) {
  return (
    <ProductCardCta render={<Link href={href} title={title} prefetch={false} />}>
      {children}
    </ProductCardCta>
  );
}
